import * as React from "react"
import {cva, type VariantProps} from "class-variance-authority"
import {cn} from "../../lib/utils"

const buttonVariants = cva(
    "inline-flex items-center justify-center whitespace-nowrap rounded-md border text-sm font-semibold transition-colors disabled:pointer-events-none disabled:opacity-50 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 ring-offset-background",
    {
        variants: {
            variant: {
                default: "border-primary bg-primary text-primary-foreground hover:bg-primary/90",
                secondary: "border-border bg-secondary text-secondary-foreground hover:bg-secondary/80",
                ghost: "border-transparent hover:bg-accent hover:text-accent-foreground",
                outline: "border border-border bg-transparent hover:bg-accent hover:text-accent-foreground",
                danger: "bg-red-600 text-white hover:bg-red-500"
            },
            size: {
                default: "h-10 px-4 py-2",
                sm: "h-9 px-3 text-xs",
                lg: "h-11 px-8",
                icon: "h-10 w-10"
            }
        },
        defaultVariants: {
            variant: "default",
            size: "default"
        }
    }
)

export interface ButtonProps
    extends React.ButtonHTMLAttributes<HTMLButtonElement>,
        VariantProps<typeof buttonVariants> {}

const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
    ({className, variant, size, ...props}, ref) => {
        return (
            <button
                ref={ref}
                className={cn(buttonVariants({variant, size}), className)}
                {...props}
            />
        )
    }
)
Button.displayName = "Button"

export {Button, buttonVariants}
